import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import {  Grid } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import TableCollapsible from '@src/components/Shared/Tables/TableColapseNoPagination';
import InvisibleContent from '@src/components/Shared/InvisibleContent';
import Cadastro from '@src/components/Shared/Solicitacao';
import Atendimento from '@src/components/Shared/SolicitacaoAtendimento';


interface IProps {
  idPerfil: number;
  triagem: string;
  tiposPerfil: string[];

}

interface ITest {

}

const Solicitacoes:React.FC<IProps> = ({
  idPerfil,
  triagem,
  tiposPerfil
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const columnsLabel = {
  };
  const [data, setData] = useState<ITest[]>([]);

  const [status, setStatus] = useState('');

  const [openCadastro, setOpenCadastro] = useState(false);
  const [openAtendimento, setOpenAtendimento] = useState(false);

  useEffect(() => {
    window.document.title = 'CRM - Solicitações atendimento';
  }, []);

  return (
    <Grid container>
      <Grid
        container
        alignItems="center"
        item
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >

        <Grid item lg={4} md={4} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            //onClick={() => setOpenModalAddCorrespondencia(true)}
            fullWidth
            style={{ height: 46, borderRadius: 5 }}
            color={status === 'Cadastro' ? 'primary' : 'default'}
            onClick={() => (setStatus('Cadastro'), setOpenCadastro(true), setOpenAtendimento(false))}
          >
            Solicitação cadastro
          </ButtonComponent>
        </Grid>

        <Grid item lg={4} md={4} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={status === 'Atendimento' ? 'primary' : 'default'}
            onClick={() => (setStatus('Atendimento'), setOpenAtendimento(true), setOpenCadastro(false))}
          >
            Solicitação atendimento
          </ButtonComponent>
        </Grid>
      </Grid>

      <InvisibleContent visible={openCadastro === true}>
          <Cadastro
          idPerfil={idPerfil} tiposPerfil={tiposPerfil} triagem={triagem} />
        </InvisibleContent>

        <InvisibleContent visible={openAtendimento === true}>
        <Atendimento idPerfil={idPerfil}/>
        </InvisibleContent>

        <InvisibleContent visible={openCadastro === false && openAtendimento === false}>
      <Grid
        container
        justify="center"
        alignItems="center"
        item
        lg={12}
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >
        <TableCollapsible
          loading={loading}
          columns={[columnsLabel]}
          FieldsBold={['']}
          data={data}
          keys={[

          ]}
       />
       </Grid>
      </InvisibleContent>


    </Grid>


  );
};

export default Solicitacoes;
